import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00034 3.25C10.0712 3.25018 11.7503 4.92905 11.7503 7V8.14746C11.7504 8.83114 11.9198 9.50424 12.2435 10.1064L13.223 11.9297C13.3008 12.0746 13.1961 12.25 13.0316 12.25H2.96811C2.80387 12.2497 2.69911 12.0745 2.7767 11.9297L3.75717 10.1064C4.08083 9.50427 4.25027 8.83111 4.25034 8.14746V7C4.25034 4.92893 5.92927 3.25 8.00034 3.25Z",
			stroke: "#0E0F10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 1.75C8.75 1.33579 8.41421 1 8 1C7.58579 1 7.25 1.33579 7.25 1.75H8.75ZM8 1.75H7.25V3H8H8.75V1.75H8Z",
			fill: "#0E0F10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74991 14.75H9.24999",
			stroke: "#0E0F10",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotification;
